/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Mapcoordinates1Inputs */

const zh_print_mapcoordinates1 = /** @type {(inputs: Print_Mapcoordinates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`坐标`)
};

const en_print_mapcoordinates1 = /** @type {(inputs: Print_Mapcoordinates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coordinates`)
};

const es_print_mapcoordinates1 = /** @type {(inputs: Print_Mapcoordinates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coordenadas`)
};

/**
* | output |
* | --- |
* | "Coordinates" |
*
* @param {Print_Mapcoordinates1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_mapcoordinates1 = /** @type {((inputs?: Print_Mapcoordinates1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Mapcoordinates1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_mapcoordinates1(inputs)
	if (locale === "en") return en_print_mapcoordinates1(inputs)
	return es_print_mapcoordinates1(inputs)
});
export { print_mapcoordinates1 as "print_mapCoordinates" }